export default function HeroSection() {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/09639fdf8aa5ee2276baded021ca887f.jpg"
          alt="Hero background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full text-center px-6 max-w-5xl mx-auto">
        <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-5 py-2 mb-8">
          <span className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse"></span>
          <span className="text-white/80 text-sm font-medium tracking-wide" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
            iOS App Development Studio
          </span>
        </div>

        <h1
          className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight"
          style={{ fontFamily: "'Space Grotesk', sans-serif", letterSpacing: '-0.02em' }}
        >
          Modern iOS Apps
          <br />
          <span className="text-emerald-400">Built for Security</span>
          <br />
          &amp; Performance
        </h1>

        <p
          className="text-white/70 text-lg md:text-xl max-w-2xl mx-auto leading-relaxed mb-12"
          style={{ fontFamily: "'Inter', sans-serif" }}
        >
          ADDON SH.P.K. is a team of experts crafting powerful iOS applications that protect your privacy and optimize your device experience.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#products"
            onClick={(e) => { e.preventDefault(); handleScroll('#products'); }}
            className="inline-flex items-center gap-2 bg-emerald-500 hover:bg-emerald-400 text-white font-semibold px-8 py-4 rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap"
            style={{ fontFamily: "'Space Grotesk', sans-serif" }}
          >
            Explore Our Products
            <i className="ri-arrow-right-line"></i>
          </a>
          <a
            href="#about"
            onClick={(e) => { e.preventDefault(); handleScroll('#about'); }}
            className="inline-flex items-center gap-2 bg-white/10 hover:bg-white/20 backdrop-blur-sm border border-white/30 text-white font-semibold px-8 py-4 rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap"
            style={{ fontFamily: "'Space Grotesk', sans-serif" }}
          >
            About Us
          </a>
        </div>

        {/* Scroll indicator */}
        <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
          <span className="text-white/40 text-xs tracking-widest uppercase" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>Scroll</span>
          <i className="ri-arrow-down-line text-white/40 text-lg"></i>
        </div>
      </div>
    </section>
  );
}
